// ABOUTME: Owner 2026-10-08 (mic_voice_control: dev + staging) - the agent's connection and voice session start at the guest's tap, so
// ABOUTME: the first words can take a few seconds: show 'Connecting to ...' from that moment until the agent first speaks (or a cap).

import { useEffect, useState } from 'react';

export const CONNECTING_CAP_MS = 20000; // never a stuck bubble: a welcome that does not come is the reconnect banner's job

/**
 * @param {object} p
 * @param {boolean} p.enabled the toggle
 * @param {boolean} p.started the guest has started the conversation (entered, film over, no CTA still holding)
 * @param {boolean} p.agentSpeaking App's isAgentSpeaking
 * @returns {boolean} show the bubble now - once per page load
 */
export default function useConnectingCue({ enabled, started, agentSpeaking }) {
  const [phase, setPhase] = useState('idle'); // idle -> connecting -> done (one pass per load)
  useEffect(() => {
    if (enabled && started && phase === 'idle') setPhase(agentSpeaking ? 'done' : 'connecting'); // already speaking: never flash
  }, [enabled, started, phase, agentSpeaking]);
  useEffect(() => { if (phase === 'connecting' && agentSpeaking) setPhase('done'); }, [phase, agentSpeaking]);
  useEffect(() => {
    if (phase !== 'connecting') return undefined;
    const t = setTimeout(() => setPhase('done'), CONNECTING_CAP_MS);
    return () => clearTimeout(t);
  }, [phase]);
  return phase === 'connecting';
}
